import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

import ThumbDown from "../../../../../../assets/images/icons/ThumbDown";
import ThumbUp from "../../../../../../assets/images/icons/ThumbUp";
import styles from "./FeedbackIntroductionContent.module.scss";

const FeedbackIntroductionContent = () => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.feedbackIntroduction" });

	return (
		<>
			<Box className={styles.feedbackRow}>
				<ThumbUp />
				<Typography variant="body2">
					<Trans i18nKey="playground.feedbackIntroduction.likeText" components={[<strong />]} />
				</Typography>
			</Box>
			<Box className={styles.feedbackRow}>
				<ThumbDown />
				<Typography variant="body2">{t("dislikeText")}</Typography>
			</Box>
		</>
	);
};

export default FeedbackIntroductionContent;
